<template>
  <div class="auth-signup">
    <div class="main boxed" v-cloak>
      <AuthHeader></AuthHeader>
      <div class="separator-3" />
      <div class="auth-agreement-step" v-if="credential">
        <div class="title-section">
          <div class="caption">
            <i class="caption__icon" v-html="iconVector"></i>
            <span class="caption__label text-caption">{{
              $t("CI SIAMO QUASI!")
            }}</span>
          </div>
          <h1 class="title text-subtitle">
            {{ $t("Completa il tuo account") }}
          </h1>
          <!--
          <div class="credential">
            <span>👉</span>
            <span>{{ credential }}</span>
          </div>
          -->
          <p class="description text-paragraph">
            {{ $t("Inserisci i tuoi dati") }}
          </p>
        </div>
        <div class="separator-1" />
        <form
          data-vv-scope="agreementsForm"
          @submit.prevent="validateForm('agreementsForm', saveAgreements)"
        >
          <div class="inline-fields">
            <div>
              <input
                type="text"
                inputmode="text"
                class="form-control"
                name="firstName"
                id="firstName"
                v-validate="'required'"
                ref="firstName"
                autofocus
                :placeholder="$t('Nome')"
                v-model="firstName"
              />
              <span
                v-if="
                  errors.has('agreementsForm.firstName') &&
                    validationFields.firstName
                "
                class="invalid-feedback"
                style="position: relative; bottom: 0px; padding-bottom: 10px;"
              >
                <strong>{{
                  $t(errors.first("agreementsForm.firstName"))
                }}</strong>
              </span>
            </div>
            <div>
              <input
                type="text"
                inputmode="text"
                class="form-control"
                name="lastName"
                id="credentials"
                v-validate="'required'"
                ref="lastName"
                autofocus
                :placeholder="$t('Cognome')"
                v-model="lastName"
              />
              <span
                v-if="
                  errors.has('agreementsForm.lastName') &&
                    validationFields.lastName
                "
                class="invalid-feedback"
                style="position: relative; bottom: 0px; padding-bottom: 10px;"
              >
                <strong>{{
                  $t(errors.first("agreementsForm.lastName"))
                }}</strong>
              </span>
            </div>
          </div>

          <div class="separator-1" />
          <div class="mb-2">
            <UiCheckbox
              v-model="agreements.tos"
              size="24"
              name="tos"
              v-validate="'required'"
            >
              <span>
                {{ $t("Ho preso visione, compreso e accetto i") }}
                <a
                  href="/info/tos"
                  target="_blank"
                  style="text-decoration: underline"
                >
                  {{ $t("Termini di Servizio") }}</a
                >
                {{ $t("di Jaked Tribe") }}
              </span>
            </UiCheckbox>
            <input
              type="hidden"
              name="privacy"
              :value="agreements.privacy || agreements.tos"
            />
            <span
              v-if="errors.has('agreementsForm.tos') && validationFields.tos"
              class="invalid-feedback"
              style="position: relative; bottom: 0px; padding-bottom: 10px;"
            >
              <strong>{{ $t(errors.first("agreementsForm.tos")) }}</strong>
            </span>
          </div>
          <div class="separator-1 separator-line" />
          <div class="separator-1" />
          <div>
            <h2 class="font-weight-bold text-paragraph">
              {{ $t("Tutela dei dati personali") }}
            </h2>
            <!--
            <div class="credential">
              <span>👉</span>
              <span>{{ credential }}</span>
            </div>
            -->
            <p class="description text-paragraph">
              {{ $t("Avendo preso visione dell'") }}
              <a
                href="https://www.iubenda.com/privacy-policy/58441074"
                target="_blank"
                style="text-decoration: underline"
              >
                {{ $t("Informativa Privacy") }}</a
              >
            </p>
          </div>
          <div class="separator-1" />

          <UiRadioGroup
            v-model="agreements.marketing"
            size="24"
            ref="marketing"
            name="marketing"
            required
            v-validate="{
              required: isNotNull('marketing') && validationFields.marketing
            }"
            :options="marketingOptions"
          >
            {{
              $t(
                "Autorizzo il trattamento dei miei dati personali per finalità di marketing."
              )
            }}
          </UiRadioGroup>

          <div class="separator-1" />
          <UiRadioGroup
            v-model="agreements.profilation"
            ref="profilation"
            size="24"
            name="profilation"
            v-validate="{
              required: isNotNull('profilation'),
              agreementsProfilation: isFalse('marketing')
            }"
            :disabled="agreements.marketing !== true"
            :options="profilationOptions"
          >
            <span :class="{ disabled: agreements.marketing !== true }">
              {{
                $t(
                  "Autorizzo il trattamento dei miei dati personali per finalità di profilazione."
                )
              }}
            </span>
          </UiRadioGroup>

          <div
            v-if="errors.items.length > 0 && edited"
            class="invalid-feedback"
            style="position: relative; bottom: 0px; padding-bottom: 10px;"
          >
            <strong>{{ errors.items.map(el => $t(el.msg)).join(", ") }}</strong>
          </div>
          <div class="actions mt-5">
            <button
              v-if="proceedAllowed"
              type="submit"
              :disabled="!proceedAllowed"
              class="button button-primary text-uppercase text-button"
            >
              {{ $t("Entra nella tribe") }}
            </button>
            <div
              v-else
              class="button button--disabled text-button text-uppercase"
            >
              {{ $t("Entra nella tribe") }}
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="image" data-step="agreements"></div>
  </div>
</template>
<script>
import iconMgm from "@/assets/svg/fnz_mgm.svg";
import iconLogout from "@/assets/svg/fnz_logout.svg";
import { changeLocale, getLocale } from "@/i18n";
import AuthHeader from "@/components/Auth/Header.vue";
import VectorIcon from "@/assets/svg/vector.svg";
import { mapGetters } from "vuex";
import UiCheckbox from "@/components/Ui/Checkbox.vue";
import UiRadioGroup from "@/components/Ui/RadioGroup.vue";
import { Actions, Mutations } from "@/store/global/global.types";
import _ from "lodash";

export default {
  name: "agreements",
  i18n: {
    messages: {
      it: {
        "Il campo tos è richiesto.":
          "L'accettazione dei Termini di servizio è obbligatoria.",
        "Il campo firstName è richiesto.": "Il campo nome è richiesto",
        "Il campo lastName è richiesto.": "Il campo cognome è richiesto",
        "Il valore del campo profilation non è valido.":
          "Il consenso alla Profilazione dipende dall'accettazione del marketing."
      }
    }
  },
  data: function() {
    return {
      agreements: {
        tos: false,
        privacy: false,
        marketing: null,
        profilation: null,
        third: false,
        third_profilation: false
      },
      validationFields: {},
      firstName: null,
      lastName: null,
      iconLogout: iconLogout,
      iconMgm,
      locale: null,
      locales: [],
      localeOpen: false,
      proceedAllowed: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    edited() {
      return Object.keys(this.validationFields).length > 5;
    },
    credential() {
      try {
        return this.user.profile.email.email;
      } catch (e) {
        return this.$t("non disponibile");
      }
    },
    iconVector() {
      return VectorIcon;
    },
    marketingOptions() {
      return [
        { label: this.$t("Do il consenso"), value: true },
        { label: this.$t("Nego il consenso"), value: false }
      ];
    },
    profilationOptions() {
      return [
        { label: this.$t("Do il consenso"), value: true },
        { label: this.$t("Nego il consenso"), value: false }
      ];
    }
  },

  async beforeMount() {
    this.generateLocales();
    this.locale = getLocale();
    // await changeLocale(this.locale, false);
    // await this.handleChangeLocale(this.locale);
    if (!this.user.id) {
      this.$store.commit(Mutations.SHOW_SPINNER);
      await this.$store.dispatch(Actions.GET_USER_PROFILE);
      this.$store.commit(Mutations.HIDE_SPINNER);
    }

    this.firstName = this.user.leaderboard.first_name;
    this.lastName = this.user.leaderboard.last_name;
    this.agreements.tos = this.user.tos;
    this.agreements.privacy = this.user.privacy;
    this.agreements.marketing =
      this.firstName === null ? null : this.user.marketing;
    this.agreements.profilation =
      this.firstName === null ? null : this.user.profilation;
  },
  methods: {
    isNotNull(val) {
      if (!_.isEmpty(this.$refs)) {
        const element = this.$refs[val];
        return element && element.currentValue === null;
      }
    },
    isFalse(val) {
      if (!_.isEmpty(this.$refs)) {
        const element = this.$refs[val];
        return element && element.currentValue === false;
      }
    },
    generateLocales() {
      const activeLocale = getLocale();
      this.locale = activeLocale;
      const locales = this.$store.state.campaign.accept_languages;
      return locales.filter(item => item !== activeLocale);
    },
    async handleChangeLocale(locale) {
      this.locale = locale;
      const locales = this.$store.state.campaign.accept_languages;
      this.locales = locales.filter(item => item !== locale);
      this.localeOpen = !this.localeOpen;
      await changeLocale(locale);
    },
    async saveAgreements() {
      try {
        const resAgreements = await this.$http.patch(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/agreements",
          this.agreements
        );

        if (this.firstName && this.lastName) {
          const payload = {
            first_name: this.firstName,
            last_name: this.lastName
          };

          const reUpdateProfile = await this.$http.post(
            "/api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/attributes",
            payload
          );
        }
        localStorage.setItem(
          "token",
          this.$store.state.authorization.access_token
        );
        await this.$store.dispatch("getUserInfo");

        if (this.$route.query.mobile) {
          setTimeout(() => {
            window.location.replace(
              `dashboard?mobile=true&access_token=${
                this.$store.state.authorization.access_token
              }`
            );
          }, 1000);
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      } catch (err) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }
    }
  },
  components: {
    UiCheckbox,
    AuthHeader,
    UiRadioGroup
  },
  watch: {
    "agreements.tos"(newVal) {
      this.proceedAllowed = false;
      this.agreements.privacy = newVal;
      this.validationFields = {
        ...this.validationFields,
        tos: true
      };
      this.validateForm("agreementsForm", () => {
        this.proceedAllowed = true;
      });
    },
    "agreements.privacy"() {
      this.proceedAllowed = false;
      this.validationFields = {
        ...this.validationFields,
        privacy: true
      };
      this.validateForm("agreementsForm", () => {
        this.proceedAllowed = true;
      });
    },
    "agreements.marketing": {
      immediate: false,
      handler(val) {
        if (val === false) {
          this.agreements = { ...this.agreements, profilation: false };
        }

        this.proceedAllowed = false;
        setTimeout(() => {
          this.validateForm("agreementsForm", () => {
            this.proceedAllowed = true;
          });
        }, 500);
      }
    },
    "agreements.profilation": {
      immediate: true,
      handler(val, oldVal) {
        this.proceedAllowed = false;

        if (oldVal !== null && typeof oldVal !== "undefined") {
          this.validationFields = {
            ...this.validationFields,
            profilation: true,
            marketing: true
          };
        }

        if (val && !this.agreements.marketing) {
          this.agreements.profilation = false;
        }

        setTimeout(() => {
          this.validateForm("agreementsForm", () => {
            this.proceedAllowed = true;
          });
        }, 500);
      }
    },
    firstName() {
      this.proceedAllowed = false;
      this.validationFields = {
        ...this.validationFields,
        firstName: true
      };
      this.validateForm("agreementsForm", () => {
        this.proceedAllowed = true;
      });
    },
    lastName() {
      this.proceedAllowed = false;
      this.validationFields = {
        ...this.validationFields,
        lastName: true
      };
      this.validateForm("agreementsForm", () => {
        this.proceedAllowed = true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.disabled {
  color: var(--fe-muted-2);
}

.auth-signup {
  min-height: calc(100vh - 44px);
  @include lg {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .image {
    background: url("/static/auth/step_1.jpg") no-repeat top right;
    background-size: cover;
  }

  .image[data-step="agreements"] {
    background-image: url("/static/auth/step_3.jpg");
  }

  input[type="checkbox"] {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    border: 1px var(--fe-base-inverted) solid;
    background: var(--fe-base);
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &[aria-checked] {
      background: 1px var(--fe-base-inverted) solid;
      background: var(--fe-base-inverted);
      color: var(--fe-base);

      &:after {
        font-size: 12px;
        font-weight: bold;
        content: "✔︎";
      }
    }
  }
}

.boxed {
  width: 100%;
  max-width: 620px;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
  @include lg {
    padding: 2rem;
  }
}

.auth-agreement-step {
  .radio-group--inline {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
  }

  .credential {
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
    align-items: center;

    .edit-action {
      display: flex;
      gap: 0.5rem;
      background: var(--fe-action-primary);
      padding: 2px 6px;
      box-sizing: border-box;
      align-items: center;
      border-radius: 50px;

      span {
        display: none;
        @include lg {
          display: inline-block;
        }
      }
    }
  }

  .actions {
    display: flex;
    width: 100%;

    .button {
      flex: 1;
      @include lg {
        flex: 0 0 auto;
      }
    }
  }

  .inline-fields {
    @include lg {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 1rem;
    }

    div {
      margin-bottom: 1rem;
      @include lg {
        margin-bottom: 0;
      }
      flex: 1;
    }
  }
}
</style>
